import React from 'react';
import { Bell, User } from 'lucide-react';
import { Button } from '../ui/button.jsx';

const Header = ({ title = 'Dashboard', user = null }) => {
  const role = user?.role || (typeof window !== 'undefined' ? localStorage.getItem('userRole') : null) || 'respondent';
  const name = user?.name
    || (typeof window !== 'undefined' ? (localStorage.getItem('userName') || localStorage.getItem('userCompany')) : null)
    || 'Usuário';
  const roleLabel = role === 'admin' ? 'Administrador' : role === 'manager' ? 'Gestora' : 'Respondente';

  return (
    <header className="bg-white border-b border-slate-200 py-4 px-8 sticky top-0 z-40" data-testid="header">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-900" data-testid="page-title">{title}</h1>
        </div>

        <div className="flex items-center gap-4">
          <Button variant="ghost" size="icon" data-testid="notifications-button">
            <Bell className="w-5 h-5 text-slate-600" />
          </Button>
          
          <div className="flex items-center gap-3 pl-4 border-l border-slate-200">
            <div className="text-right" data-testid="user-info">
              <p className="text-sm font-medium text-slate-900">{name}</p>
              <p className="text-xs text-slate-500">{roleLabel}</p>
            </div>
            <div className="w-10 h-10 bg-accent rounded-full flex items-center justify-center" data-testid="user-avatar">
              <User className="w-5 h-5 text-white" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;